import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, _mergeProps(_ctx.$attrs, { onClick: _ctx.viewClientProfile }), {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          (_ctx.data.numNewPosts === 0)
            ? (_openBlock(), _createBlock(_component_q_item_label, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.data.client.name), 1),
                  _createTextVNode(" added their " + _toDisplayString(_ctx.data.platform) + " account but it contains no posts. ", 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_q_item_label, { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.data.client.name), 1),
                  _createTextVNode(" imported " + _toDisplayString(_ctx.data.numNewPosts) + " " + _toDisplayString(_ctx.data.platform) + " post(s). ", 1)
                ]),
                _: 1
              })),
          _createVNode(_component_q_item_label, { caption: "" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["onClick"]))
}